import { Grid } from "@mui/material";
import React from "react";
import CapitalAmountHeader from "./home/header";
import CapitalAmountTable from "./home/table";

const CapitalAmount = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <CapitalAmountHeader />
      </Grid>
      <Grid item xs={12}>
        <CapitalAmountTable />
      </Grid>
    </Grid>
  );
};

export default CapitalAmount;
